import { render } from "./comprehensive_liveness_verification.html?vue&type=template&id=2f0d5f35&scoped=true&external"
import script from "./comprehensive_liveness_verification.js?vue&type=script&lang=js&external"
export * from "./comprehensive_liveness_verification.js?vue&type=script&lang=js&external"

import "./ComprehensiveLivenessVerificationReport.vue?vue&type=style&index=0&id=2f0d5f35&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0d5f35"]])

export default __exports__